import { Component, OnInit } from '@angular/core';
import { SsInventoryService } from 'shared/services/SS-Inventory/ss-inventory.service';
import { Router } from '@angular/router';
import { DataSharingService } from 'shared/services/data-sharing/data-sharing.service';
import { UserService } from 'shared/services/User/user.service';
import { AppComponent } from 'app/app.component';
import { AlertPopupService } from 'shared/services/SS-Alert/alert-popup.service';

@Component({
  selector: 'app-choose-team-public',
  templateUrl: './choose-team-public.component.html',
  styleUrls: ['./choose-team-public.component.css']
})
export class ChooseTeamPublicComponent implements OnInit {
  loading: boolean;
  teams: any;

  constructor(
    private inventoryService: SsInventoryService,
    private router: Router,
    private data: DataSharingService,
    private userService: UserService,
    private alertService: AlertPopupService,
    private app: AppComponent,
  ) { }

  ngOnInit() {
    this.data.changeTitle('CHOOSE TEAM');
    this.loading = true;
    this.inventoryService.getPublicInventory().subscribe(res => {
      this.loading = false;
      this.teams = res.products;
    }, err => {
      this.loading = false;
      this.alertService.errorAlertWithResult('Team Not Avaiable', 'Go Back', '/new-group');
    });
  }

  selectTeam(team) {
    this.app.toggleLoadingMsg('Fetching Open Groups');
    // check if user has a team connected
    this.router.navigate(['/new-group/public-groups'],{queryParams: {team_id: team.team_id}})
  }

  back() {
    this.router.navigate(['/new-group']);
  }

}



// WEBPACK FOOTER //
// ./src/app/modules/group/components/choose-team-public-groups/choose-team-public.component.ts